/**
 * Records every goal selected in the COAST exit-intent form. The Klaviyo
 * on-site script associates anonymous activity with the profile once the
 * visitor submits their email address in the following step.
 */
(() => {
  const goalChoices = {
    'coast-exit-goal--grow_my_glutes_and_legs': {
      label: 'Grow my glutes & legs',
      value: 'grow_my_glutes_and_legs',
    },
    'coast-exit-goal--get_leaner_and_more_defined': {
      label: 'Get leaner & more defined',
      value: 'get_leaner_and_more_defined',
    },
    'coast-exit-goal--feel_more_energised_when_i_train': {
      label: 'Feel more energised when I train',
      value: 'feel_more_energised_when_i_train',
    },
    'coast-exit-goal--less_brain_fog_more_focus': {
      label: 'Less brain fog, more focus',
      value: 'less_brain_fog_more_focus',
    },
  };

  document.addEventListener('click', (event) => {
    const choice = event.target.closest('.coast-exit-goal-choice');
    if (!(choice instanceof HTMLElement) || choice.dataset.coastGoalTracked === 'true') return;

    const goal = Object.entries(goalChoices).find(([className]) => choice.classList.contains(className))?.[1];
    if (!goal) return;

    choice.dataset.coastGoalTracked = 'true';
    window._learnq = window._learnq || [];
    window._learnq.push([
      'track',
      'Exit Popup Goal Selected',
      {
        goal_label: goal.label,
        goal_value: goal.value,
        form_name: 'COAST — Exit Intent Goals | Desktop',
      },
    ]);
  });
})();
